import React from "react";
import { Link } from "react-router-dom";
import RouteNames from "../routes/type";

const NotAuthorizedPage: React.FC = () => {
  return (
    <div className="bg-gray-100 h-[calc(100vh-67px)] flex flex-col items-center justify-center p-4">
      <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>

        <h1 className="text-8xl font-black text-primary tracking-tighter">
          403
        </h1>

        <h2 className="mt-2 text-3xl md:text-4xl font-bold text-gray-800">
          Access Denied
        </h2>

        <p className="mt-4 text-gray-600">
          Sorry, you do not have the necessary permissions to access this page.
          Contact your administrator if you believe this is an error.
        </p>

        <div className="mt-8">
          <Link
            to="/contracts"
            className="inline-block px-8 py-3 font-semibold text-gray-900 bg-primary rounded-lg shadow-md hover:bg-primaryHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primaryHover transition-all duration-300 ease-in-out"
          >
            Return to Contract
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorizedPage;
